module.exports = __webpack_public_path__ + "img/612.Appliances.3e7d92ea.svg";